import styled from 'styled-components';

import { fontSizes, fontWeights } from '../../../theme';

import DefaultDataTableCell, {
  DefaultDataTableCellProps,
} from './DefaultDataTableCell';

/**
 * styled(CellView) returns type with incorrect type inference for TData,
 * so we create generic wrapper around it that drills props and cast response where `CellProps` are `any`
 * as workaround for this issue
 */
const Container = styled(DefaultDataTableCell<any>)`
  font-size: ${fontSizes.m};
  font-weight: ${fontWeights.medium};
`;

const DataTableHighlightedCell = <TData,>(
  props: DefaultDataTableCellProps<TData>,
) => <Container {...props} />;

export default DataTableHighlightedCell;
